<template>
  <div>
    <header>
      <Header />
      <BreadcrumbList />
    </header>
    <div>
      <div id="main">
        <section class="artWorkCateTop">
          <div v-if="this.$route.path === '/artworks/Tcc10Sen'" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>東京カメラ部10選</h1>
              <p class="titleSub">The 10 Photographers</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div v-else-if="this.$route.path === '/artworks/Japan100Views'" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>日本写真100景</h1>
              <p class="titleSub">100 Cultural &amp; Landscape Photos of Japan</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div v-else-if="this.$route.path === '/artworks/MyPrecious'" class="artWorkCateTopTitle">
            <div class="inner4">
              <h1>"My Precious" Photo Contest</h1>
              <p class="titleSub">「大切な存在」フォトコンテスト</p>
            </div><!-- /inner4-->
          </div><!-- /photographersListTitle-->

          <div class="artWorkCateTopBody">
            <div class="inner2">
              <div v-if="this.$route.path === '/artworks/Tcc10Sen'" class="listBlock">
                <template v-for="awardType of this.awardTypeList()">
                  <div :key="awardType">
                    <h2>{{awardTypeNames[awardType]}}</h2>
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerList(awardType)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="getSelectedWork(winner).imageUrlS" :alt="winner.name" />
                              </router-link>
                          </div>
                          <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->
                  </div>
                </template>
              </div><!-- /listBlock-->

              <div v-else-if="this.$route.path === '/artworks/Japan100Views'" class="listBlock">
                <template v-for="area of areas">
                  <div :key="area.id">
                    <h2>{{area.name}}エリア</h2>
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerListByArea(area)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.winningWorks[0].imageUrlS" :alt="winner.winningWorks[0].title" />
                              </router-link>
                          </div>
                          <p v-if="winner.winningWorks[0].title" class="prefectures">{{winner.winningWorks[0].title}}</p>
                          <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->
                  </div>
                </template>
                <div class="inner2 photospot100inner">
                  <div class="photospot100">
                    <h4>日本写真100景フォトスポットサイト</h4>
                    <p>「日本写真100景」の入選作品を地図や季節から探す事ができるサイトです。作品が撮影された場所を緯度・経度から地図上で確認できるほか、一部のフォトスポットにはおすすめの観光情報や作品解説も掲載しています。ぜひご覧ください。</p>
                    <a class="StandardBtn" href="https://japanphotospot.tokyocameraclub.com/" target="_black" onclick="">日本写真100景フォトスポットサイトへ</a>
                  </div>
                </div><!-- /inner2-->
              </div><!-- /listBlock-->

              <div v-else-if="this.$route.path === '/artworks/MyPrecious'" class="listBlock">
                <template v-for="category of ['大切なあの人', '愛しい生きもの']">
                  <div :key="category">
                    <h2>「{{category}}」部門</h2>
                    <div class="listBlockInner">
                      <template v-for="(winner, index) of winnerListByCategory(category)">
                        <div :key="winner.id" class="exhibitor" :class="{ rowLast: (index % 5 === 4)}">
                          <div class="thumbnailImg">
                              <router-link :to="workUrl(winner)">
                                <img :src="winner.winningWorks[0].imageUrlS" :alt="winner.winningWorks[0].title" />
                              </router-link>
                          </div>
                          <h3><router-link :to="workUrl(winner)">{{ winner.name }}</router-link></h3>
                        </div>
                      </template>
                    </div><!-- /listBlockInner-->
                  </div>
                </template>
              </div><!-- /listBlock-->
            </div><!-- /inner2-->
          </div><!-- /photographersListBody-->
        </section><!-- /photobook-->

      </div><!-- /main-->
    </div>
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    BreadcrumbList,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    getArtworksCode (winner) {
      if (!this.awardTypeCode || !winner) return
      return this.awardTypeCode[winner.awardType]
    },
    getSelectedWork (winner) {
      // 10選2019以外は、先頭オブジェクトを返す
      if (winner.awardType === this.EnumAwardTypeTcc10Sen2019) {
        // 10選2019は、10選作品を返す
        for (const work of winner.winningWorks) {
          if (work.isSelection) {
            return work
          }
        }
      } else {
        return winner.winningWorks[0]
      }
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    awardTypeList () {
      if (this.$route.path === '/artworks/Tcc10Sen') {
        return [1, 2, 3, 4, 5, 6, 7, 8]
      } else if (this.$route.path === '/artworks/Japan100Views') {
        return [9]
      } else if (this.$route.path === '/artworks/MyPrecious') {
        return [10]
      }
    },
    winnerList (type) {
      return this.winners.filter((winner) => { return winner.awardType === type })
    },
    winnerListByArea (area) {
      const winners = this.winnerList(this.EnumAwardTypeJapan100Views)
      return winners.filter((winner) => {
        return this.prefecturesMap[winner.winningWorks[0].title] === area.name
      })
    },
    winnerListByCategory (category) {
      const winners = this.winnerList(this.EnumAwardTypeMyPrecious)
      return winners.filter((winner) => {
        let ret = false
        if (category === '大切なあの人') {
          ret = [200004, 200009, 200008, 200006, 200007].indexOf(winner.id) >= 0
        } else if (category === '愛しい生きもの') {
          ret = [200003, 200010, 200002, 200001, 200005].indexOf(winner.id) >= 0
        }
        return ret
      })
    },
    workUrl (winner) {
      if (winner.awardType >= 1 && winner.awardType <= 8) {
        return `/artworks/${this.awardTypeCode[winner.awardType]}/${winner.id}`
      } else if (winner.awardType === 9) {
        return `/artworks/Japan100Views/${winner.id}`
      } else if (winner.awardType === 10) {
        return `/artworks/MyPrecious/${winner.id}`
      }
    }
  },
  created () {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
